import React from 'react'
import { t } from 'src/translations'
import { BrandedButton } from 'shared/components/common/button'
import { ButtonType } from 'src/apollo/sites'
import { Helmet } from 'react-helmet-async'
import UnavailableIcon from 'shared/components/errors/UnavailableIcon'
import { StyleMetaProps } from 'public/components/default_template/meta/StyleMeta'
import { SiteTheme } from 'shared/js/types'

const NotFound404 = ({
  meta,
  siteTheme,
  errorMessage,
  ctaUrl
}: {
  meta?: StyleMetaProps
  siteTheme?: SiteTheme
  errorMessage?: string
  ctaUrl?: string
}) => {
  const color = siteTheme?.brandColor ?? meta?.primaryColor ?? '#FF4C00'
  return (
    <div className='errorPageContainer'>
      <Helmet>
        <title>{t('not-found-404.page-title')}</title>
      </Helmet>
      {/* The icon is marked as aria-hidden */}
      {/* eslint-disable-next-line @toasttab/buffet/icon-accessibility */}
      <UnavailableIcon color={color} />
      <div className='textContent'>
        <div className='header'>404</div>
        <div className='subheader'>{t('not-found-404.title')}</div>
        {errorMessage && <div className='description'>{errorMessage}</div>}
      </div>
      {ctaUrl && (
        <a href={ctaUrl} rel='noopener noreferrer'>
          <BrandedButton
            variant={ButtonType.Primary}
            style={{ backgroundColor: color, color: '#FFFFFF' }}
            className='returnToHomepageButton'
          >
            {t('not-found-404.cta')}
          </BrandedButton>
        </a>
      )}
    </div>
  )
}

export default NotFound404
